import axios from "../../Axios";
import { Urls } from "../../Urls";

// removed azure search bcoz it has hardcoded api key

export const getUserData = () => {
  return axios.get(Urls.locationapi2);
};

export const getUserDetails = () => axios.get(Urls.user_data);

/**
 * Checks if the user is a first time user or not
 * @param {string} value - passing `userDetails.firsttimeuser` is mandatory
 * @returns {boolean} true if user is first time user
 */
export const isFirstTimeUser = (value) => {
  if (value === undefined || value === null) {
    return true;
  }

  if (value === "true" || value === true) {
    return true;
  } else if (value === "false" || value === false) {
    return false;
  } else {
    console.log(
      "something wrong in user details : first time user key should be boolean"
    );
    return false;
  }
};
